module.exports = __webpack_public_path__ + "img/W-S37.0cb29265.jpg";